export class ScpAuditPreviousSerialModel{

    serial:string;
    codigoSap:string;
    descripcion:string;
    motivoScrap:string;
    estado:string;

    constructor(){}
}